import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  list4uBusAutomations,
  listExamMachineModality,
} from "../../../../../../services/uBusAutomationRobot";

const translationPath = "page.4uBus.uBusAutomationRobot.";

export const ExamMachineModalitySelect = memo(() => {
  const { t } = useTranslation();

  const [options, setOptions] = useState<ISelectType[]>([]);

  const { setValue } = useFormContext();

  const { sendRequest } = useFetch(listExamMachineModality);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest(undefined);
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: item.id,
          name: item.name,
          code: String(item.code),
        }))
      );
    }
  }, [sendRequest]);

  const valueChangeHandler = useCallback(() => {
    setValue("examMachine", null);
  }, [setValue]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <AutoComplete
      name="examMachineModality"
      label={t(translationPath + "machine_mode")}
      getOptionLabel={(option) => option.name}
      size="small"
      fullWidth
      options={options}
      onValueChange={valueChangeHandler}
    />
  );
});
